<div class="delivery-specialist-feedback-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="specialistFeedbacks()"></grid-content>
</div>